export const OBTAIN_METHOD = {
  MANUFACTURED: 'manufactured',
  PURCHASED: 'purchased',
} as const;

export const TEMP_PART_UUID_PREFIX = 'TEMP_PART_UUID_PREFIX';
